import { RiLink } from 'react-icons/ri';
import { handleChange,getError } from '../../helperFunctions';
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import { Label, TextInput, Toggle, HelperText } from "../../../components/UiComponents/Ui";
import { callbackMethodOptions, redirects } from '../supplierUtils';



const SectionHeader = ({
  title,
  description,
  checked,
  onChange,
  readOnly,
}) => (
  <div className="flex items-center justify-between">
    <div className="space-y-1">
      <h2 className="text-xl font-semibold text-gray-600">{title}</h2>
      <p className="text-xs font-[400] text-gray-600">{description}</p>
    </div>
    <Toggle
      checked={checked}
      onChange={onChange}
      className={readOnly ? 'pointer-events-none' : ''}
    />
  </div>
);

const Redirects = ({
  supplierData,
  setSupplierData,
  formErrors,
  setFormErrors,
  readOnly = false,
}) => {
  const onChange = (path, value) =>
    handleChange(path, value, setSupplierData, setFormErrors, formErrors);

  const urlInputs = (field ) => (
    <div className="space-y-2">
      {redirects?.map((item) => {
        const err = getError([field, item?.label], formErrors);
        return (
          <div className="space-y-1" key={item.label}>
            <Label required>{item.name}</Label>
            <TextInput
              type="url"
              required
              readOnly={readOnly}
              endIcon={<RiLink size={16} />}
              placeholder={`Enter ${item.name}`}
              value={(supplierData)?.[field]?.[item?.label] || ''}
              error={err}
              onChange={(e) => onChange([field, item.label], e.target.value)}
            />
            {!!err && <HelperText>{err}</HelperText>}
          </div>
        );
      })}
    </div>
  );

  const methodError = getError(['serverCallbackMethod'], formErrors);

  const content = (
    <div className="space-y-8">
      {/* global redirects */}
      <section className="space-y-2">
        <SectionHeader
          title="Global Redirects"
          description="Enter the global redirect URLs for the supplier end page redirection."
          checked={supplierData?.globalRedirects}
          readOnly={readOnly}
          onChange={(e) => onChange(['globalRedirects'], e.target.checked)}
        />
        {supplierData?.globalRedirects && (
          <div className="rounded-lg border border-gray-200 px-3 py-4 shadow-sm">
            {urlInputs('redirects')}
          </div>
        )}
      </section>

      {/* server callbacks */}
      <section className="space-y-2">
        <SectionHeader
          title="Server Callbacks"
          description="Enter the server callback URLs for the supplier for server to server communication."
          checked={supplierData?.serverCallback}
          readOnly={readOnly}
          onChange={(e) => onChange(['serverCallback'], e.target.checked)}
        />
        {!!supplierData?.serverCallback && (
          <div className="space-y-3 rounded-lg border border-gray-200 px-3 py-4 shadow-sm">
            <div className="flex items-center justify-between">
              <Label required className="text-lg font-semibold">
                Server Callback Method
              </Label>
              <MultiSelectDropdown
                options={callbackMethodOptions}
                dropdownText="Select Method"
                width="190px"
                disabled={readOnly}
                selected={[
                  {
                    label:
                      (callbackMethodOptions || []).find(
                        (d) => d.value === supplierData?.serverCallbackMethod,
                      )?.label || '',
                    value: supplierData?.serverCallbackMethod || '',
                  },
                ]}
                setSelected={(e) => {
                  const value = e;
                  onChange(['serverCallbackMethod'], value?.[0]?.value);
                }}
              />
            </div>
            {!!methodError && <HelperText>{methodError}</HelperText>}
            {urlInputs('serverCallbackEndpoints')}
          </div>
        )}
      </section>
    </div>
  );

  if (readOnly) return content;

  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-4/5">{content}</div>
    </div>
  );
};

export default Redirects;